import React from 'react';
import { Text, TouchableOpacity, StyleSheet } from 'react-native';
import Ionicons from '@expo/vector-icons/Ionicons';
import { useI18n } from '../../i18n';
import { fontWeights } from '../../styles/typographyTokens';
import { ACCENT_TEXT } from '../../styles/accentText';
import { useReflectionLauncher } from '../reflection/reflectionLauncher';
import type { ReflectionOfferAction } from '../../services/chat/chatTypes';

// CORE-1751 (возврат QA 23.10) — подпись, глиф и обводка — акцентный текст
// CORE-1733, а не фирменный #E98245: тот на сливочном фоне чата давал 2.5:1 при
// 13 px. Токен — #9A421F в светлой теме и #F0A06D в тёмной (CSS-переменная,
// переключается с темой); натив по CORE-1733 остаётся прежним.
const INK = ACCENT_TEXT;

/**
 * CORE-1751 — кнопка под сообщением Агапеллы: «записать пару строк» о
 * Live-сессии, после которой человек ушёл, не увидев окна.
 *
 * Открывает то же окно, что после практики и при выходе из комнаты, и запись
 * привязывается к завершению этой сессии — поэтому в дневнике она подписана её
 * названием. Одна кнопка на веб-тред, виджет и нативный чат: разойтись трём
 * копиям было бы проще, чем одной.
 */
export function ReflectionOfferButton({ offer }: { offer: ReflectionOfferAction }) {
  const { t } = useI18n('dashboard');
  const { openReflection } = useReflectionLauncher();
  return (
    <TouchableOpacity
      testID={`reflection-offer-${offer.completionId}`}
      accessibilityRole="button"
      accessibilityLabel={t('journal.reflection.offerButton')}
      activeOpacity={0.85}
      onPress={() => openReflection({ completionId: offer.completionId, source: 'chat_offer' })}
      style={styles.button}
    >
      <Ionicons name="book-outline" size={16} color={INK} />
      <Text style={styles.label}>{t('journal.reflection.offerButton')}</Text>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  button: {
    flexDirection: 'row', alignItems: 'center', alignSelf: 'flex-start', gap: 6,
    borderWidth: 1, borderColor: INK, borderRadius: 999,
    paddingHorizontal: 14, paddingVertical: 8,
  },
  label: { color: INK, fontSize: 13, fontWeight: fontWeights.semibold },
});
